import { AutoComplete, Select, message } from "antd";
import React, { useEffect, useState } from "react";
import { apiCall } from "../utils/Api"

export default function FormSelect(props) {

    const {onChange = () => {}, value = ""} = props; 

    const [results, setResults] = useState({rows : []});

    const fetchLists = () => {
        apiCall("settings/custom_forms/listAll", {}, (_status, _result) => {
            if (_status) {
                setResults(_result);
            }
        })
    }
    useEffect(fetchLists, []);


    const getOptions = () => {

        return results.rows.map(item => {

            let _itm = item;
            _itm.label = item.header;
            _itm.value = item.id;
            return _itm; 
        })
    }

    const returnSelect = (_id) => {

       let ret = results.rows.find(item => item.id === _id)

       if(ret){
            onChange({list_id : _id, actual_list_id : ret.id})
       }

       else {
            message.error("List id not found.")
            onChange({list_id : _id, actual_list_id : 0})
       }

    } 



    return (
        <>
            <Select popupClassName="bm-select" optionFilterProp="label" showSearch style={{"width" : "100%", "fontSize" : "11px"}} defaultValue={(value) ? value : null} placeholder="Select List..." onChange={(e) => returnSelect(e)} options={getOptions()} />
        </>
    )
}